<script setup lang="ts">
/**
 * NotFoundPage（F01）。
 *
 * `/:catchAll(.*)` 命中时渲染。显式提示 + 返回首页按钮，
 * 不做静默重定向（Debug-First）。
 */
import { RouterLink } from 'vue-router';

import { copy } from '@/i18n/zh-CN';
</script>

<template>
  <main :class="$style.page">
    <h1 :class="$style.title">{{ copy.notFound.title }}</h1>
    <p :class="$style.description">{{ copy.notFound.description }}</p>
    <RouterLink :class="$style.link" to="/">
      {{ copy.notFound.backHome }}
    </RouterLink>
  </main>
</template>

<style module>
.page {
  max-width: var(--container-max);
  margin: 0 auto;
  padding: var(--space-6) var(--space-3);
  text-align: center;
}

.title {
  color: var(--color-brand-primary);
  font-size: var(--font-size-xl);
  margin-bottom: var(--space-2);
}

.description {
  color: var(--color-text-secondary);
  font-size: var(--font-size-md);
  margin-bottom: var(--space-3);
}

.link {
  display: inline-block;
  padding: var(--space-1) var(--space-3);
  border: 1px solid var(--color-brand-primary);
  border-radius: var(--radius-md);
  color: var(--color-brand-primary);
  font-size: var(--font-size-base);
}
</style>
